var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 33,
    viewBox: "0 0 22 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H22V33H12C5.37258 33 0 27.6274 0 21V12Z",
    fill: "url(#paint0_linear_80_38266)",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3492 16.5034L8.08625 13.4693C7.97922 13.3697 7.97063 13.1995 8.06707 13.089C8.16351 12.9785 8.32846 12.9697 8.43549 13.0692L11.9138 16.3036C12.0288 16.4106 12.0287 16.5969 11.9135 16.7038L8.43528 19.931C8.32813 20.0304 8.16319 20.0213 8.06687 19.9108C7.97055 19.8002 7.97932 19.63 8.08647 19.5306L11.3492 16.5034Z",
    fill: "#2E2E2E",
    stroke: "#2E61D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3492 16.5034L12.0863 13.4693C11.9792 13.3697 11.9706 13.1995 12.0671 13.089C12.1635 12.9785 12.3285 12.9697 12.4355 13.0692L15.9138 16.3036C16.0288 16.4106 16.0287 16.5969 15.9135 16.7038L12.4353 19.931C12.3281 20.0304 12.1632 20.0213 12.0669 19.9108C11.9706 19.8002 11.9793 19.63 12.0865 19.5306L15.3492 16.5034Z",
    fill: "#2E2E2E",
    stroke: "#2E61D6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_80_38266",
    x1: 33,
    y1: 20,
    x2: -2,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E61D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E61D6",
    stopOpacity: 0.25
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.a359036c61e5445fde55ec0713c387cd.svg";
export { ForwardRef as ReactComponent };